import { useApiAuth } from './api-auth-context';

export function useAppAuth() {
  const api = useApiAuth();

  return {
    isAuthenticated: api.isAuthenticated,
    isLoading: api.isLoading,
    user: api.user,
    token: api.user?.access_token,
    settings: null,
    logout: api.logout,
    source: 'api',
  };
}
